import { graphql } from 'GQL/gql';

graphql(`
  fragment userSkillFields on UserSkill {
    __typename
    _id
    skillId
    userId
    improve
    improveNotes
    isShareable
    like
    level
    origin
    createdAt
    deleted
    updatedAt
    proofPointId
    suggestion {
      suggestedBy {
        _id
        profile {
          name
        }
      }
      suggestedAction
      isImprove
      level
      comment
    }
    managerAssessment {
      confirmedAt
      status
    }
    skill {
      _id
      type
      trends {
        _id
        trendIcon
        replaceability
        demand
      }
      synonym(policiesPreset: $policiesPreset) {
        _id
        skillId
        synonymId
        synonymLang
        synonymString
        synonymLevelDescriptions {
          _id
          level
          description
        }
        companySpecific {
          _id
          isLogoVisible
          definition
        }
      }
    }
  }
`);

export const GET_VIEWER_SKILLS = graphql(`
  query GET_VIEWER_SKILLS($policiesPreset: PoliciesPresetInput) {
    viewerSkills {
      ...userSkillFields
    }
  }
`);
